var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 106.06 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#6c63ff;}.cls-1,.cls-3,.cls-7{opacity:0.1;}.cls-1,.cls-14,.cls-18,.cls-31,.cls-7{isolation:isolate;}.cls-2{fill:#fff;}.cls-31,.cls-4{opacity:0.2;}.cls-6{fill:#ffd2c6;}.cls-8{fill:#626696;}.cls-9{fill:#ffcde5;}.cls-10{fill:#985c7e;}.cls-11{fill:url(#linear-gradient);}.cls-12{fill:#cc818c;}.cls-13{fill:#444053;}.cls-14,.cls-27{opacity:0.05;}.cls-15{fill:#ff748f;}.cls-16,.cls-18{fill:#575988;}.cls-17{fill:#dce6f2;}.cls-18{opacity:0.5;}.cls-19{fill:#67647e;}.cls-20{fill:#585268;}.cls-21{fill:#e4aab4;}.cls-22{fill:#ffd037;}.cls-23{fill:#65617d;}.cls-24{fill:#9d9cb5;}.cls-25{fill:url(#linear-gradient-2);}.cls-26{fill:#2d293d;}.cls-28{fill:#ffcdd3;}.cls-29{fill:#656691;}.cls-30{fill:#a8a8a8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 220.52,
    y1: 3603.08,
    x2: 220.52,
    y2: 3642.14,
    gradientTransform: "matrix(1, 0, 0, -1, -138.09, 3646.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 118.93,
    y1: 3568.83,
    x2: 118.93,
    y2: 3613.19,
    gradientTransform: "matrix(1, 0, 0, -1, -61.06, 3646.51)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gfx-account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.32,11c-4.55,3.86-10.45,3.61-15.63,1.6S39.77,7,34.73,4.43A42,42,0,0,0,21.58.27C15.16-.62,8,.47,3.51,6.71c-5,7-4.6,19.5.79,25.88C7,35.84,10.63,37.43,13.76,40s6,6.75,5.76,11.64c-.25,4.53-3.12,8-6.09,10.19-2.3,1.69-5.12,3.53-5.4,7s2.11,6,4.38,7.53a21.11,21.11,0,0,0,23.91-.12c2.63-1.78,5-4.15,7.81-5.53,7.25-3.64,15.23,0,22.91,1.36a38.12,38.12,0,0,0,19.48-1.72C90.33,69,94.14,66.89,96.81,63c1.93-2.79,3.13-6.33,4.25-9.83q1.8-5.59,3.46-11.25a33.37,33.37,0,0,0,1.49-7,25.13,25.13,0,0,0-2.78-12.45C99,13.68,91.85,7.48,84.12,5.91s-15.91,1.5-21.9,8.22"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 48.17,
    cy: 52.4,
    rx: 22.33,
    ry: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.42,48.19A20.25,20.25,0,1,1,67.67,27.94,20.27,20.27,0,0,1,47.42,48.19Zm0-40.3A20.05,20.05,0,1,0,67.47,27.94,20.07,20.07,0,0,0,47.42,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.42,43.65a15.7,15.7,0,1,1,15.7-15.7A15.72,15.72,0,0,1,47.42,43.65Zm0-31.21A15.51,15.51,0,1,0,62.93,27.94,15.53,15.53,0,0,0,47.42,12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.42,38.77A10.82,10.82,0,1,1,58.24,27.94,10.82,10.82,0,0,1,47.42,38.77Zm0-21.45A10.63,10.63,0,1,0,58,27.94,10.63,10.63,0,0,0,47.42,17.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 96.43,
    cy: 39.67,
    rx: 1.4,
    ry: 0.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 17.57,
    cy: 64.14,
    rx: 8.27,
    ry: 1.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.06,26.54H6.84a1.32,1.32,0,0,0-1.32,1.32V43.8a1.32,1.32,0,0,0,1.32,1.32H26.63s.51,2.72-1.17,3c0,0,3.77.27,3.11-3h3.5a1.32,1.32,0,0,0,1.32-1.32V27.86A1.32,1.32,0,0,0,32.06,26.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.23,
    y: 30.77,
    width: 20.44,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.23,
    y: 36.34,
    width: 20.44,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.23,
    y: 39.12,
    width: 17.14,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.23,
    y: 33.55,
    width: 8.86,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.28,26.43H7.05a1.32,1.32,0,0,0-1.32,1.32V43.69A1.32,1.32,0,0,0,7.05,45H26.85s.51,2.72-1.17,3c0,0,3.77.27,3.11-3h3.5a1.32,1.32,0,0,0,1.32-1.32V27.75A1.32,1.32,0,0,0,32.28,26.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.45,
    y: 30.66,
    width: 20.44,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.45,
    y: 36.23,
    width: 20.44,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.45,
    y: 39.01,
    width: 17.14,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.45,
    y: 33.44,
    width: 8.86,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.92,26.18l-1.4,3a2.55,2.55,0,0,1-.34.66,15.37,15.37,0,0,0-.72,1.87L19,34h0l-.1.16L18.27,34l-.41-1.54,0-.45v-.06a9.23,9.23,0,0,1,1.13-1s.16,0,.47-.73a1.92,1.92,0,0,1,.59-.92l.16-.54L22,25.94s1.46-2.09,1.85-1.16S22.92,26.18,22.92,26.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M17.11,47.3a.33.33,0,0,1,0,.14c-.16.23-1.07,5-1.07,5a2.72,2.72,0,0,1-.27,1.27,18.23,18.23,0,0,0-.43,1.82A31.09,31.09,0,0,1,15,59.39,4,4,0,0,0,15.1,61a2.48,2.48,0,0,0,.47,1.32l0,.05.1.13a.77.77,0,0,0,.21.25l0,0a2.34,2.34,0,0,0,.82.35h0l.2,0,.07.39-.78.16-1.49.1s-1.75.13-1.35-.65a1.24,1.24,0,0,0,.07-.17h0l0-.12a4,4,0,0,0,.08-1.66L13.3,58.6a10.74,10.74,0,0,1,.44-5.22,1.27,1.27,0,0,1,.1-.78,5.24,5.24,0,0,0,0-1.78s-.1-1.57-.24-2.35a4.76,4.76,0,0,1-.05-1,4.93,4.93,0,0,1,.05-.58L17,46.44A2.59,2.59,0,0,1,17.11,47.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.06,63.58l-.78.16-1.49.1S13,64,13.45,63.2a1.23,1.23,0,0,0,.07-.17h0l0-.12a2.7,2.7,0,0,1,.89.18.81.81,0,0,0,.87-.31l.24-.46,0-.07.1.13a.79.79,0,0,0,.25.29l0,.09-.24.49s.3,0,.71.1a.32.32,0,0,0,.39-.21h0l.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M17.79,64c-.06.26-1.7.35-1.7.35s-.91-.09-1.17.13-1,.16-1,.16-.43,0-.58-.73.2-.82.22-.82h0a2.67,2.67,0,0,1,.93.18.81.81,0,0,0,.87-.31l.28-.53.1.13a.78.78,0,0,0,.25.29l-.28.58s.3,0,.71.1a.34.34,0,0,0,.42-.32.33.33,0,0,0,0,0l.57.16A.59.59,0,0,1,17.79,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M20.88,50.81c0,.24-.08.84-.08.84a4.83,4.83,0,0,1-.22,1.72l-.18.69a14,14,0,0,1-.49,3s-.38,2-.57,2.87a2.38,2.38,0,0,0,.1,1.44l0,0a.17.17,0,0,0,0,0l0,.07a1.06,1.06,0,0,0,.2.33l.11.11h0a2.13,2.13,0,0,0,.63.38h0l.1,0,.31.1h0l-.08.46-1-.27-1.39-.45-.69-.39,0-.11h0l0-.11A14.09,14.09,0,0,0,18,58.11a12.34,12.34,0,0,1,.64-4.2,2.55,2.55,0,0,0,.12-.9,6.14,6.14,0,0,1-.31-1.86s-.47-1-.86-2a5.21,5.21,0,0,1-.28-1,3.61,3.61,0,0,1-.06-.75s3.16-2.88,3.51-.09l0,.27A10.2,10.2,0,0,1,20.88,50.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.88,62.54,20.8,63l-1-.27-1.39-.45-.69-.39,0-.11h0l0-.11h.11a1.31,1.31,0,0,1,.58.08c.23.09.52.18.58.14a.74.74,0,0,1,.33-.06l.14-.32,0,0a1.05,1.05,0,0,0,.2.33l.11.11v.27a2,2,0,0,0,.5.23.29.29,0,0,0,.14,0h0l.1,0,.31.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20.36,63.53c-.29-.08-1-.22-1.1-.11a3.78,3.78,0,0,1-1.08,0,.59.59,0,0,1-.5-.3,3.08,3.08,0,0,1,0-1.33h.2a1.3,1.3,0,0,1,.58.08A1.4,1.4,0,0,0,19,62a.73.73,0,0,1,.33-.06l.17-.37a1.06,1.06,0,0,0,.2.33l.11.11v.27a2,2,0,0,0,.5.23.2.2,0,0,0,.24-.08l0,0h0a1.69,1.69,0,0,0,.41.14h0a.75.75,0,0,1,.8.58C21.91,63.56,20.65,63.61,20.36,63.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.11,47.3l-.18.05a2.47,2.47,0,0,1-.43.09,18.08,18.08,0,0,1-2.95,0,5,5,0,0,1,.05-.58L17,46.44A2.63,2.63,0,0,1,17.11,47.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20,46.48s-1.23.19-2.23.41c-.33.07-.64.15-.87.22a2.67,2.67,0,0,1-.43.09,19.51,19.51,0,0,1-3.1,0c-.54-1.77.66-4,.66-4a2.24,2.24,0,0,1,.25-.72v0l.17-.63h4.58l.06.27.12.55L20,46.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.75,47.55h0l-.54.24a11,11,0,0,1-2.92.32,3.61,3.61,0,0,1-.06-.75s3.16-2.88,3.51-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20.83,47.28l-.11,0-.54.24a11.14,11.14,0,0,1-3,.32h-.15a.69.69,0,0,1-.53-.32s0-.21-.05-.36l0-.22a13.74,13.74,0,0,1-1.78-.92c-.45-.31-.34-2.48-.25-3.57,0-.38.06-.62.06-.62l4.63.27.65,0,.37.08.1,0a15.85,15.85,0,0,0,.39,2.1c.13.16,0,.71,0,1a1.89,1.89,0,0,1,0,.39,2.43,2.43,0,0,1,.15.85A1.69,1.69,0,0,0,20.83,47.28Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 15.87,
    cy: 29.25,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.95,30s.13,1.8-.24,2.21a16.44,16.44,0,0,1-1.32,1.19l.3,1.22,1.66.19,1.94-2.08-.44-.54a3.17,3.17,0,0,1-.06-1.72C17.07,29.94,14.95,30,14.95,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19,34h0l-.1.16L18.27,34l-.41-1.54,0-.45.12-.17s.65,0,.62.6A5.16,5.16,0,0,0,19,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.24,42.51s-.47.1-1,.17a2.91,2.91,0,0,1-1.41,0,13.41,13.41,0,0,0-3.4-.15h-.11l.17-.63h4.58l.06.27.65,0,.37.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.89,31.95s.65,0,.62.6a5.43,5.43,0,0,0,.35,1.6l-.15.34s-.21.82,0,1,.75.21.41,1.9a6.06,6.06,0,0,0,.1,1.68,13.45,13.45,0,0,0,.44,1.81,9.94,9.94,0,0,1,.62,1.37s-1.91.43-2.41.13a15.46,15.46,0,0,0-3.58-.14s0-.52,0-.57a.49.49,0,0,1,.07-.38c.1-.14.26-.37.18-.58s.22-.51.06-.83-.36-.38-.32-.56a.75.75,0,0,0-.18-.56c-.12-.15-.91-1.7-.91-1.7L13,36.36s-1-.75-1-1.1a2.07,2.07,0,0,1,.39-.84l1-1s.54.59,1.07.38a9.78,9.78,0,0,0,1.67-1.19s.41-.22.44-.38.28,0,.28,0,.37-.2.44-.13a1.28,1.28,0,0,0,.39.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.33,35l-.31.25a4.19,4.19,0,0,0-.39,1.6,22,22,0,0,1-.39,2.49l-.62,1.11a27.91,27.91,0,0,0-1.15,2.7,7,7,0,0,1-.74,1.52s-2,1.84-.62,2.16,1.47-1.46,1.47-1.46a1.93,1.93,0,0,0,.39-.62c.05-.25,1.86-3.45,1.86-3.45s.63-.86.5-1.32a13.74,13.74,0,0,0,.82-2.42A8.61,8.61,0,0,0,13,36.36l.13-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M16.57,39.07a14.61,14.61,0,0,1-1.72.79l1.22-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.74,39.66a9.16,9.16,0,0,1-2.76.53S17.08,40.58,17.74,39.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.86,39.87s-1.72,1.08-2.74.91c0,0,2.37.47,2.74.22l-1.06-.3S18,40.08,17.86,39.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M15.88,25.91a1.79,1.79,0,0,0-1.45.27c-.3.23-.49.59-.82.76a4.81,4.81,0,0,1-.54.19,1.55,1.55,0,0,0-.95,1.67c.05.3.19.56.26.85a3.32,3.32,0,0,1-.12,1.56,16.44,16.44,0,0,1-1.64,4.06.43.43,0,0,0-.08.27.39.39,0,0,0,.1.17,3.84,3.84,0,0,0,2.83,1.09,2.14,2.14,0,0,0,1.12-.19,1.69,1.69,0,0,0,.55-.5,2.66,2.66,0,0,0,.51-1.71,4.7,4.7,0,0,1-.07-1.47.39.39,0,0,1,.09-.18c.11-.11.3-.08.46-.1a1,1,0,0,0,.76-.94,10.69,10.69,0,0,0-.06-1.3,2.72,2.72,0,0,1,.51-1.6,1.73,1.73,0,0,0,.38-.64,1.07,1.07,0,0,0-.27-.79,3.86,3.86,0,0,0-.73-1.12A2,2,0,0,0,15.88,25.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M15.76,25.79a1.79,1.79,0,0,0-1.45.27c-.3.23-.49.59-.82.76a4.75,4.75,0,0,1-.54.19A1.55,1.55,0,0,0,12,28.69c.05.3.19.56.26.85a3.32,3.32,0,0,1-.12,1.56,16.45,16.45,0,0,1-1.64,4.06.42.42,0,0,0-.08.27.38.38,0,0,0,.1.17,3.84,3.84,0,0,0,2.83,1.09,2.14,2.14,0,0,0,1.12-.19A1.7,1.7,0,0,0,15,36a2.66,2.66,0,0,0,.51-1.71,4.67,4.67,0,0,1-.07-1.47.39.39,0,0,1,.09-.18c.11-.11.3-.08.46-.1a1,1,0,0,0,.76-.94,10.5,10.5,0,0,0-.06-1.3,2.73,2.73,0,0,1,.51-1.61,1.72,1.72,0,0,0,.37-.64,1.07,1.07,0,0,0-.27-.79,3.82,3.82,0,0,0-.73-1.12A2,2,0,0,0,15.76,25.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M15.12,44.19a5.2,5.2,0,0,0,1,2.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.11,29.08,12,28.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.48,27.54a.64.64,0,0,1,0,.17,1.74,1.74,0,0,1-.38.64,2.72,2.72,0,0,0-.51,1.6,11.09,11.09,0,0,1,.06,1.3,1,1,0,0,1-.76.94c-.16,0-.35,0-.46.1a.39.39,0,0,0-.09.18,4.8,4.8,0,0,0,.07,1.47,2.66,2.66,0,0,1-.51,1.71,1.71,1.71,0,0,1-.55.5,2.2,2.2,0,0,1-1.12.19,3.87,3.87,0,0,1-2.79-1.05.27.27,0,0,0,0,.14.38.38,0,0,0,.1.17,3.84,3.84,0,0,0,2.83,1.09,2.14,2.14,0,0,0,1.12-.18A1.71,1.71,0,0,0,15,36a2.66,2.66,0,0,0,.51-1.71,4.67,4.67,0,0,1-.07-1.47.39.39,0,0,1,.09-.18c.11-.11.3-.08.46-.1a1,1,0,0,0,.76-.94,10.49,10.49,0,0,0-.06-1.3,2.72,2.72,0,0,1,.51-1.6,1.72,1.72,0,0,0,.37-.64A.73.73,0,0,0,17.48,27.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.29,75.17s-3.74-.23-3.3,2.4a.64.64,0,0,0,.33.67s0-.2.38-.13a1.72,1.72,0,0,0,.41,0,.85.85,0,0,0,.5-.21h0a3,3,0,0,0,1.46-2.16s.3-.37.3-.47l-.63.27a1.13,1.13,0,0,1,0,.83s0-.82-.14-.8-.33.16-.33.16a1.87,1.87,0,0,1,.09,1.37s.11-1-.21-1.31l-.44.26a2,2,0,0,1,.14,1.49,2.79,2.79,0,0,0-.23-1.43l-.4.31a1.92,1.92,0,0,1,.16,1.36s0-1.19-.25-1.28a2.42,2.42,0,0,0-.41.44s.28.59.11.9c0,0-.11-.8-.2-.8a2.65,2.65,0,0,0-.39.89,1.92,1.92,0,0,1,.3-.94,1.05,1.05,0,0,0-.54.28s.05-.37.62-.41a2.69,2.69,0,0,1,.37-.42,2.31,2.31,0,0,0-.91.11,1,1,0,0,1,1-.2l.39-.32a3.4,3.4,0,0,0-1.06,0A1.29,1.29,0,0,1,49.64,76l.43-.26a3.93,3.93,0,0,0-1-.09,1.55,1.55,0,0,1,1.14,0l.31-.14-.6-.11c-.14,0-.14-.05-.14-.05a1.61,1.61,0,0,1,.87.1A4,4,0,0,0,51.29,75.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 48.71,
    cy: 78.47,
    rx: 2.65,
    ry: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.62,72s-3.74-.23-3.3,2.4a.64.64,0,0,0,.33.67s0-.2.38-.13a1.73,1.73,0,0,0,.41,0,.84.84,0,0,0,.5-.21h0a3,3,0,0,0,1.46-2.15s.3-.38.3-.47l-.64.28a1.14,1.14,0,0,1,0,.83s0-.82-.14-.8-.33.16-.33.16a1.87,1.87,0,0,1,.09,1.37s.11-1-.21-1.31l-.44.26a2,2,0,0,1,.14,1.49A2.79,2.79,0,0,0,79,72.95l-.4.31a1.92,1.92,0,0,1,.16,1.36s0-1.2-.25-1.29a2.46,2.46,0,0,0-.41.44s.28.59.11.9c0,0-.11-.8-.2-.8a2.65,2.65,0,0,0-.39.89,1.91,1.91,0,0,1,.3-.94,1.06,1.06,0,0,0-.54.28s.06-.37.62-.41a2.69,2.69,0,0,1,.37-.42,2.31,2.31,0,0,0-.91.11,1,1,0,0,1,1-.19l.39-.32a3.39,3.39,0,0,0-1.06,0A1.29,1.29,0,0,1,79,72.78l.43-.26a3.9,3.9,0,0,0-1-.09,1.56,1.56,0,0,1,1.14,0l.31-.14-.6-.11c-.14,0-.14-.05-.14-.05a1.61,1.61,0,0,1,.88.1A4,4,0,0,0,80.62,72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 78.05,
    cy: 75.27,
    rx: 2.65,
    ry: 0.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 83.45,
    cy: 42.98,
    rx: 7.63,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M92.33,18.3a4.1,4.1,0,0,0,0-2.09v-1a3.45,3.45,0,0,0-1.23-3.17l-1.05-.93a4,4,0,0,0-.76-.54h-.1l0,0a3.17,3.17,0,0,1-.23-.49.45.45,0,0,0,.38-.13.49.49,0,0,0,.09-.15h0c.06-.14.07-.3.12-.45a1,1,0,0,1,.2-.32l0,.05c.15-.18.34-.34.48-.54l.08-.12,0,0a2.7,2.7,0,0,0,.31-1.05,1,1,0,0,0,0-.38,1.25,1.25,0,0,0-.11-.24c-.23-.47-.22-1.06-.59-1.44a1.76,1.76,0,0,0-1.08-.42,2.8,2.8,0,0,1-1.14-.28,1.23,1.23,0,0,0-.31-.17.25.25,0,0,0-.3.11.2.2,0,0,1,0,.08.13.13,0,0,1-.12,0l-.52-.14v0h0l0,.08a0,0,0,0,1,0,0l-.08.13a1.29,1.29,0,0,1-.47-.1.18.18,0,0,0,0,0h0c0,.15.16.24.21.38a.29.29,0,0,1,0,.19.42.42,0,0,1-.1.15c-.19.18-.42.15-.64.26a.13.13,0,0,0-.08.09.06.06,0,0,0,0,0,.11.11,0,0,0,0,.05,1,1,0,0,0,.2.13l-.06.06a2.34,2.34,0,0,0,.81,3.81l0,.13h0v.06l-.7.3a.56.56,0,0,1-.5-.32c-.16-.34-.74,0-.74,0a6.94,6.94,0,0,0-2.42.19s-1.05-.44-1.2-.47-.37-.15-.48-.12-.24-.2-.31-.18-.1-.15-.34-.21-.33,0-.59-.25a23.18,23.18,0,0,0-2.43-1.31l-1-.8-1-.82,0,0,0-.08a9.87,9.87,0,0,0-.38-1.21c-.07-.16-.1-.36-.19-.25s-.15-.08-.3-.17a.25.25,0,0,0-.34.06l0,0h0c-.81,1.27-1.1,1.36-.63,1.82s.69.78,1,.89h0l2,2.36A11.81,11.81,0,0,0,78,11.23c1,.4.9.52.9.52a22.35,22.35,0,0,0,3.42,1.48c.46,0,.37,3.08.18,3.58s-.5,4.12-.5,4.12a1.74,1.74,0,0,0,0,1.3,8.17,8.17,0,0,1,0,1.26,4.32,4.32,0,0,0-.72,1.85,1,1,0,0,1,0,.11l-.07.06.07,0a3.73,3.73,0,0,1-.2.89,3.61,3.61,0,0,0-.24,1.28V30l-.2,1.45s-.24,1.1,0,1.35a.62.62,0,0,1,.13.45.84.84,0,0,0,.15.53.4.4,0,0,1,.1.34c-.08.25.12,3,.12,3a3,3,0,0,1-.14.79c-.08,0,.13.86.13.86s-.8.67-.6,1l.2.31-.05.05,0,0a.31.31,0,0,0-.2,0,7.64,7.64,0,0,1-.81.72,8.73,8.73,0,0,1-1.34.64l-.78.06h0s-.37,0-.16.54,2.07.39,2.07.39l1.08-.17A20.81,20.81,0,0,0,83,42.17c.23-.05.29-.18.27-.3h0a.77.77,0,0,0-.16-.33v0l0-.39c.82-.47-.23-1.41-.23-1.41a9.38,9.38,0,0,1,.55-1,30.76,30.76,0,0,0,.18-4s.1-1.36-.16-1.67a.57.57,0,0,1,.28-.51,18.37,18.37,0,0,0,1.17-3.27l.27,1.68a2.39,2.39,0,0,0,.12,1,.4.4,0,0,1,.07.31,1.39,1.39,0,0,0,0,.68.44.44,0,0,0,.14.24c.16.08.17.36.23.42s.42-.08.44.13a4.75,4.75,0,0,1,0,.57l.12,3.5a2.29,2.29,0,0,0-.24,1.06,1.37,1.37,0,0,1-.14.63.32.32,0,0,0,0,.38l0,0-.15.11a.32.32,0,0,0-.09.39.32.32,0,0,0-.09.34l0,.06a.55.55,0,0,0-.3.15,2.42,2.42,0,0,1-.52.53,9.84,9.84,0,0,0-.83.71,1.19,1.19,0,0,1-.49.39l-.15,0c-.39.08-.27.49,0,.55a5.26,5.26,0,0,0,2.18.2.76.76,0,0,0,.6-.08,8.24,8.24,0,0,1,1.16-.39s.44,0,.5-.18a.67.67,0,0,0,0-.17h0a2.33,2.33,0,0,0,0-.39c0-.07,0-.13,0-.18s-.11-.34-.14-.42v0c.17-.29-.11-1-.11-1a1.88,1.88,0,0,1,.34-.39A25.74,25.74,0,0,0,88.61,37a2.76,2.76,0,0,1,.2-1.14,8.18,8.18,0,0,0-.3-2.49s-.22-.49-.14-.67a2.34,2.34,0,0,0-.08-.82v-.77a.85.85,0,0,0,0-.27,1.29,1.29,0,0,1-.05-.79c.14-.35.45-2.53.45-2.53a2.92,2.92,0,0,1,.11-1.73l.1-.18a2.65,2.65,0,0,0,.06-1.77l-.06-.27,0-.11,0,0a1.32,1.32,0,0,1,0-.16,1.08,1.08,0,0,0,.71-.49A8,8,0,0,1,91.3,21.3a1.48,1.48,0,0,0,.86-1c-.12-.21.21-1,.21-1Zm-2.6,1.36-.86,1h0c-.22-.31.21-1,.21-1l.71-1.59a1,1,0,0,1-.09.47c-.2.27.36.71.36.71-.3,0-.33.42-.33.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M74.65,6.64l-.47.91a1.81,1.81,0,0,1-.44-.09,1.65,1.65,0,0,1-1-.89,1.28,1.28,0,0,1,.6-1.69c.32-.18.62-.38.86.2a10,10,0,0,1,.38,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M89.5,11.37l-.75,1.11s-3.53,1.68-2.85-.3a4.46,4.46,0,0,0,.28-1.95h0a1.54,1.54,0,0,0-.28-.79s3.44-1.76,2.93-.56a1.67,1.67,0,0,0-.12.79,2.7,2.7,0,0,0,.37,1.1A3.65,3.65,0,0,0,89.5,11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M88.43,33.39a8.19,8.19,0,0,1,.3,2.48,2.8,2.8,0,0,0-.2,1.13A25.8,25.8,0,0,1,88,40.16a1.87,1.87,0,0,0-.33.39s.28.69.11,1a.23.23,0,0,1-.11.1c-.26.11-1.23-.38-1.78-.68a.3.3,0,0,1-.15-.17.31.31,0,0,1,.09-.34.32.32,0,0,1,.09-.39l.14-.11,0,0a.32.32,0,0,1,0-.37,1.38,1.38,0,0,0,.14-.62,2.27,2.27,0,0,1,.23-1.05l-.12-3.47a5,5,0,0,0,0-.57c0-.21-.38-.07-.44-.13s-.07-.34-.22-.42a.44.44,0,0,1-.14-.24,1.4,1.4,0,0,1,0-.68.4.4,0,0,0-.07-.31,2.38,2.38,0,0,1-.12-1l-.27-1.67a18.43,18.43,0,0,1-1.16,3.25.56.56,0,0,0-.27.51c.25.31.16,1.66.16,1.66a30.89,30.89,0,0,1-.18,4,9.69,9.69,0,0,0-.54,1s1,.93.22,1.4h0c-.84.47-2.58-.84-2.58-.84l.18-.18.05-.05-.2-.31c-.2-.35.59-1,.59-1s-.21-.82-.13-.86a3,3,0,0,0,.13-.78s-.19-2.69-.11-2.95a.39.39,0,0,0-.09-.34.84.84,0,0,1-.15-.52.62.62,0,0,0-.13-.45c-.23-.25,0-1.35,0-1.35l.2-1.44v-2.3a3.64,3.64,0,0,1,.24-1.29,3.9,3.9,0,0,0,.21-1,4.36,4.36,0,0,1,.73-1.87c.14-.22.25-.35.25-.35L88.58,23s.1.28.2.67l.06.27a2.65,2.65,0,0,1-.06,1.76,1.39,1.39,0,0,0-.1.18,2.92,2.92,0,0,0-.11,1.72s-.31,2.16-.45,2.52a1.26,1.26,0,0,0,.05.78.87.87,0,0,1,0,.27v.77a2.36,2.36,0,0,1,.08.82C88.22,32.9,88.43,33.39,88.43,33.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88.72,25.73l-.1.18-.35,0c0-.18-.21-1.88-.21-1.88l.71,0A2.64,2.64,0,0,1,88.72,25.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M88.78,25.68a1.36,1.36,0,0,0-.1.18l-.35,0c0-.18-.2-1.88-.2-1.88l.71,0A2.63,2.63,0,0,1,88.78,25.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M88.78,25.68a1.36,1.36,0,0,0-.1.18l-.35,0c0-.18-.2-1.88-.2-1.88l.71,0A2.63,2.63,0,0,1,88.78,25.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.75,41.52a.23.23,0,0,1-.11.1c-.26.11-1.23-.38-1.78-.68a.3.3,0,0,1-.15-.17c.31-.06.52.3.52.3a.46.46,0,0,1,.64.14h0c.27.39.84.23.84.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.91,42.72c-.06.18-.5.18-.5.18a9.34,9.34,0,0,0-1.14.4.78.78,0,0,1-.59.08,5.27,5.27,0,0,1-2.15-.2c-.31-.06-.43-.47,0-.55l.14,0a1.18,1.18,0,0,0,.48-.39,9.92,9.92,0,0,1,.82-.71,2.38,2.38,0,0,0,.52-.52c.46-.41.79.15.79.15a.46.46,0,0,1,.64.14h0c.27.39.84.23.84.23s.1.26.15.45,0,.11,0,.18A1.54,1.54,0,0,1,87.91,42.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 86.57,
    cy: 41.43,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 86.11,
    cy: 41.86,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 85.64,
    cy: 42.25,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 85.88,
    cy: 42.08,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 86.35,
    cy: 41.63,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M87.91,42.72c-.06.18-.5.18-.5.18a9.34,9.34,0,0,0-1.14.4.78.78,0,0,1-.59.08,5.27,5.27,0,0,1-2.15-.2c-.31-.06-.43-.47,0-.55l.14,0a3.74,3.74,0,0,0,1.06.2c.8,0,1.42,0,1.42,0l.8-.26a1.35,1.35,0,0,1,.5-.18,1.28,1.28,0,0,0,.49-.21A1.54,1.54,0,0,1,87.91,42.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M85.9,43.23h-.13v-.06a.85.85,0,0,0,.48-.07l.21-.1.25-.11.08,0,.13,0,.07,0,.18-.07h.19l.17-.06.18-.07h0a.21.21,0,0,0,.13,0l0,0a.26.26,0,0,1-.16.06h0l-.17.06-.18.07H87.2l-.17.06-.07,0-.14,0-.08,0L86.5,43l-.22.1A1,1,0,0,1,85.9,43.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.09,33.53a1.42,1.42,0,0,1,1.1-.58,3.76,3.76,0,0,0,1-.08,2.46,2.46,0,0,1-.75.3A12.69,12.69,0,0,0,86.09,33.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.33,33.66a1.63,1.63,0,0,1,.58-.26l.39,0a1.11,1.11,0,0,1-.32.16C86.79,33.58,86.33,33.66,86.33,33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.4,33.84s.55,0,.56.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.27,25.61a2.2,2.2,0,0,0,.55-.72.5.5,0,0,1,.21-.31s.32.13,0,.52A1.57,1.57,0,0,1,81.27,25.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88.83,8.87c-.11.27-.21.29-.19.54a2,2,0,0,1-.45.35c-.35.21-.73.61-1.16.61a2.3,2.3,0,0,1-.85-.16,1.54,1.54,0,0,0-.28-.79S89.34,7.67,88.83,8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M89.36,7.94A2.33,2.33,0,1,1,87,5.61a2.33,2.33,0,0,1,2.33,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.5,11.37l-.75,1.11s-3.53,1.68-2.85-.3a4.46,4.46,0,0,0,.28-1.95h0a1.85,1.85,0,0,1,.07.45c0,.3,0,.69.77.81a2.11,2.11,0,0,0,2-.73A3.64,3.64,0,0,0,89.5,11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.65,6.64l-.47.91a1.81,1.81,0,0,1-.44-.09l0,0c.19.07.83-1.14.83-1.14l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88.77,23.65c-1.51.65-6.72.1-6.72.1a.66.66,0,0,0,0-.17c.14-.22.25-.35.25-.35L88.57,23S88.67,23.26,88.77,23.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M86.19,10.29l-.69.3a.56.56,0,0,1-.5-.32c-.16-.34-.73,0-.73,0a6.81,6.81,0,0,0-2.39.19s-1-.44-1.18-.47-.37-.15-.47-.12-.23-.19-.31-.18-.1-.15-.34-.2-.32,0-.59-.25a23.26,23.26,0,0,0-2.4-1.3l-1-.79-1-.82S74,7.54,73.78,7.47l1.95,2.34a11.64,11.64,0,0,0,2.37,1.62c1,.39.89.51.89.51a21.83,21.83,0,0,0,3.38,1.46c.45,0,.37,3.06.18,3.56s-.5,4.1-.5,4.1a1.72,1.72,0,0,0,0,1.29,7.23,7.23,0,0,1,0,1.27s5.25.56,6.73-.1a11.34,11.34,0,0,0,0-2.74c-.22-.31.21-1,.21-1l.93-2.1,2.28-2.3A3.44,3.44,0,0,0,91,12.25l-1-.92a3.86,3.86,0,0,0-.75-.53c-.17,0-.11,0-.11,0a2.11,2.11,0,0,1-2.07.75c-.75-.13-.76-.51-.77-.81A1.85,1.85,0,0,0,86.19,10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89,18.17s-3.22.13-3.86,1.14A3.2,3.2,0,0,1,86.76,19C87.51,19.15,89,18.17,89,18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.49,21.7s1.52.1,1.84-.22.32-.51.32-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.36,15.07s-1.29,1.52.28,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.73,12.12s.47,1,.7,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.15,11.71a17.51,17.51,0,0,0,1.39,1.16A9.73,9.73,0,0,0,80.15,11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.82,10.7s-1.13,1.68-.39,2.71A3.6,3.6,0,0,1,84.82,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M87.66,23.45l-.34.32,0,0-.4.38-.09.06c-1.62,1.16-1.95-.6-1.95-.6s-.72.47-.82.09,1.67-.92,1.93-.89H86a1.11,1.11,0,0,0,.36-.13l.08,0,.26-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.41,7.94a2.33,2.33,0,0,1-1.14,2l-.08-.17c-.08-.2-.13-.4-.22-.6a1.87,1.87,0,0,0-.39-.57.25.25,0,0,0-.1-.07.28.28,0,0,0-.21.06,1,1,0,0,1-.32.14.35.35,0,0,1-.33-.1.49.49,0,0,1-.05-.41,5.05,5.05,0,0,0,.15-.91.9.9,0,0,0-.38-.79,3.42,3.42,0,0,0-.79-.17l-.12,0a2.33,2.33,0,0,1,4,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M85.26,5.94s-.09.06-.08.11a.11.11,0,0,0,0,.05,1,1,0,0,0,.37.19,3.23,3.23,0,0,1,.79.17.89.89,0,0,1,.38.79,5.31,5.31,0,0,1-.15.91.49.49,0,0,0,.05.41.35.35,0,0,0,.33.1,1,1,0,0,0,.32-.14.28.28,0,0,1,.21-.06.26.26,0,0,1,.1.07,1.85,1.85,0,0,1,.39.57c.08.2.14.4.22.6a1,1,0,0,0,.39.49.49.49,0,0,0,.59-.06c.14-.15.13-.38.2-.57s.44-.54.64-.83a2.54,2.54,0,0,0,.35-1.12.94.94,0,0,0,0-.37,1.35,1.35,0,0,0-.1-.24c-.23-.47-.22-1.06-.58-1.43a1.74,1.74,0,0,0-1.07-.41,2.75,2.75,0,0,1-1.13-.28,1.24,1.24,0,0,0-.3-.17.25.25,0,0,0-.3.11.2.2,0,0,1,0,.08.13.13,0,0,1-.11,0l-.52-.14.06.26a1.28,1.28,0,0,1-.55-.1c0,.15.16.24.21.38a.35.35,0,0,1-.1.36C85.71,5.86,85.47,5.83,85.26,5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.17,40.91l0,.23h0c-.84.47-2.58-.84-2.58-.84l.18-.18a.31.31,0,0,1,.08.24l.36,0,.42.46a8,8,0,0,0,1.46.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M83,42.19a20.5,20.5,0,0,1-2.46.11l-1.07.17s-1.84.18-2-.39.16-.54.16-.54h0l.77-.06a8.61,8.61,0,0,0,1.33-.63,7.65,7.65,0,0,0,.8-.71s.32-.06.31.31l.36,0,.42.46a8,8,0,0,0,1.46.06h.11l0,.57v0C83.21,41.65,83.52,42.08,83,42.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 81.05,
    cy: 40.77,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 79.67,
    cy: 41.36,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 78.96,
    cy: 41.58,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 80.03,
    cy: 41.25,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 79.32,
    cy: 41.47,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 80.4,
    cy: 41.08,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 80.76,
    cy: 40.92,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M83,42.19a20.5,20.5,0,0,1-2.46.11l-1.07.17s-1.84.18-2-.39.16-.54.16-.54h0a1,1,0,0,0,.81.33l1.32.05,1.37-.1s1.28,0,1.49-.08a3.09,3.09,0,0,0,.51-.19C83.21,41.65,83.52,42.08,83,42.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M79.6,42.34l-.22,0,0-.05a1.06,1.06,0,0,0,.55,0l.2-.06a2.23,2.23,0,0,1,.95-.11h0A9,9,0,0,0,82.89,42a.65.65,0,0,0,.38-.15l0,0a.71.71,0,0,1-.41.17,9.12,9.12,0,0,1-1.77.08h0a2.88,2.88,0,0,0-.58,0l-.35.09-.2.06A1.46,1.46,0,0,1,79.6,42.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.66,23.45l-.34.32-.86-1.1.26-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M91.54,14.47l.67.94v1a4.1,4.1,0,0,1,0,2.08l0,.91s-.33.83-.21,1a1.47,1.47,0,0,1-.85,1,8,8,0,0,0-1.68,1.43,1.15,1.15,0,0,1-1.24.5l-.86.37-1-1.27,1.35-.73s.47-.63.75-.6l1.14-1.33s0-.42.32-.42c0,0-.54-.44-.35-.7s0-1.43,0-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.28,18.74s1.54,0,1.73.37S90.75,18.52,90.28,18.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.27,23.75a.4.4,0,0,1,0,.08.52.52,0,0,1-.48.44h0a.52.52,0,0,1-.52-.52.53.53,0,0,1,0-.17.89.89,0,0,1-.25-.73,1.11,1.11,0,0,0,.36-.13,2.43,2.43,0,0,0,.25.52h.12a.52.52,0,0,1,.52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M86.43,22.61s-.35.08-.35.14-.08.63.3.87.34-.33.34-.33S86.4,22.79,86.43,22.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 86.81,
    cy: 23.75,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 86.81,
    cy: 23.75,
    r: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.8,23.95a2.56,2.56,0,0,0,2.5.33v.44a2,2,0,0,1-1.79.25C84.66,24.58,84.8,23.95,84.8,23.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.8,23.83a2.56,2.56,0,0,0,2.5.33v.44a2,2,0,0,1-1.79.25C84.66,24.46,84.8,23.83,84.8,23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M84.8,23.83a2.56,2.56,0,0,0,2.5.33v.44a2,2,0,0,1-1.79.25C84.66,24.46,84.8,23.83,84.8,23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M84.83,23.83a2.56,2.56,0,0,0,2.5.33v.44a2,2,0,0,1-1.79.25C84.69,24.47,84.83,23.83,84.83,23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.37,40.13s1.46.27,1.68.33-.06.16-.06.16A5.93,5.93,0,0,1,81.37,40.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.33,39.35s1-.27,1.2-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82.75,33.75s.39.52.65.5S83,33.73,82.75,33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83,34.61s.17.37.41.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M83.89,26.58l1,2.74A6.31,6.31,0,0,0,84.76,27,.91.91,0,0,0,83.89,26.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.44,4.88v0l-.17,0,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,5.54l0,0a.35.35,0,0,0,.1-.36A.48.48,0,0,0,86,5L85.78,5c0,.15.16.24.21.38A.3.3,0,0,1,86,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.75,10a1,1,0,0,1-.39-.49c-.08-.2-.13-.4-.22-.6a1.83,1.83,0,0,0-.39-.57.25.25,0,0,0-.1-.07.28.28,0,0,0-.21.06,1,1,0,0,1-.32.14.35.35,0,0,1-.33-.1A.49.49,0,0,1,86.72,8a5.06,5.06,0,0,0,.15-.91.88.88,0,0,0-.38-.79,3.38,3.38,0,0,0-.79-.17A1,1,0,0,1,85.34,6l0,0-.06,0s-.09.06-.08.11a.12.12,0,0,0,0,.06,1,1,0,0,0,.37.19,3.27,3.27,0,0,1,.79.17.89.89,0,0,1,.38.79,5.3,5.3,0,0,1-.15.91.49.49,0,0,0,.05.41.35.35,0,0,0,.33.1,1,1,0,0,0,.32-.14.28.28,0,0,1,.21-.06.26.26,0,0,1,.1.07,1.85,1.85,0,0,1,.39.57c.08.2.13.4.22.6a1,1,0,0,0,.39.49.5.5,0,0,0,.59-.06.46.46,0,0,0,.09-.15A.5.5,0,0,1,88.75,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,9.3c.15-.19.34-.34.48-.54l.08-.12A4.87,4.87,0,0,0,89.59,9.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.91,6.53H57.62a1.22,1.22,0,0,0-1.22,1.22V22.46a1.22,1.22,0,0,0,1.22,1.22H75.89s.47,2.51-1.08,2.78c0,0,3.48.25,2.87-2.78H80.9a1.22,1.22,0,0,0,1.22-1.22V7.75A1.22,1.22,0,0,0,80.91,6.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 10.44,
    width: 18.86,
    height: 1.15,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 15.58,
    width: 15.56,
    height: 1.15,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.83,
    y: 13.01,
    width: 11.2,
    height: 1.15,
    rx: 0.56,
    ry: 0.56
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.21,6.33H57.93a1.22,1.22,0,0,0-1.22,1.22V22.26a1.22,1.22,0,0,0,1.22,1.22H76.19s.47,2.51-1.08,2.78c0,0,3.48.25,2.87-2.78h3.23a1.22,1.22,0,0,0,1.22-1.22V7.55A1.22,1.22,0,0,0,81.21,6.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.14,
    y: 10.24,
    width: 18.86,
    height: 1.15,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.14,
    y: 15.37,
    width: 15.56,
    height: 1.15,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.14,
    y: 12.8,
    width: 11.2,
    height: 1.15,
    rx: 0.56,
    ry: 0.56
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8,54.41s.35.46-.16,1.15-.94,1.28-.76,1.71c0,0,.77-1.29,1.4-1.3S8.67,55.19,8,54.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8,54.41a.58.58,0,0,1,.07.14c.61.72.94,1.4.35,1.41S7.19,57,7,57.22a.18.18,0,0,0,0,.06S7.83,56,8.46,56,8.67,55.19,8,54.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M8.63,55c0,.16,0,.3,0,.3s0-.13,0-.3,0-.09,0-.09S8.63,54.84,8.63,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M8.86,55.19c-.14.08-.27.12-.28.1s.1-.1.24-.18.09,0,.1,0S9,55.11,8.86,55.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.13,54.41s-.35.46.16,1.15.94,1.28.76,1.71c0,0-.77-1.29-1.4-1.3S5.44,55.19,6.13,54.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6.13,54.41a.58.58,0,0,0-.07.14c-.62.72-.94,1.4-.35,1.41s1.21,1,1.37,1.25l0,.06S6.28,56,5.65,56,5.44,55.19,6.13,54.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M5.48,55c0,.16,0,.3,0,.3s0-.13,0-.3,0-.09,0-.09S5.48,54.84,5.48,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M5.25,55.19c.14.08.27.12.28.1s-.1-.1-.24-.18-.09,0-.1,0S5.11,55.11,5.25,55.19Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 7.05,
    cy: 60.22,
    rx: 3.67,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M8.95,56.66l0,.14,0,.2v.08l0,.2v.08l0,.2-.28,2.3c0,.21-.36.37-.77.37H6.33c-.41,0-.74-.16-.77-.37l-.28-2.3,0-.2v-.08l0-.2V57l0-.2,0-.14c0-.12.17-.21.39-.21h3C8.77,56.44,9,56.54,8.95,56.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "8.92 56.8 8.9 57 5.21 57 5.18 56.8 8.92 56.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "8.89 57.09 8.87 57.29 5.24 57.29 5.22 57.09 8.89 57.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "8.85 57.37 8.83 57.58 5.28 57.58 5.25 57.37 8.85 57.37"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 63.54,
    cy: 77.67,
    rx: 8.27,
    ry: 1.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.12,36H47.89a1.32,1.32,0,0,0-1.32,1.32V53.26a1.32,1.32,0,0,0,1.32,1.32H67.68s.51,2.72-1.17,3c0,0,3.77.27,3.11-3h3.5a1.32,1.32,0,0,0,1.32-1.32V37.32A1.32,1.32,0,0,0,73.12,36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.29,
    y: 45.8,
    width: 20.44,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.29,
    y: 43.02,
    width: 8.86,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.91,35.78H47.67a1.32,1.32,0,0,0-1.32,1.32V53a1.32,1.32,0,0,0,1.32,1.32H67.46s.51,2.72-1.17,3c0,0,3.77.27,3.11-3h3.5A1.32,1.32,0,0,0,74.22,53V37.1A1.32,1.32,0,0,0,72.91,35.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.07,
    y: 45.58,
    width: 20.44,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 50.07,
    y: 42.8,
    width: 8.86,
    height: 1.25,
    rx: 0.56,
    ry: 0.56
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M68.3,76.75c-.12-.5-.2-.95-.2-.95a2,2,0,0,0-.22-1V74.7h0v-1a3.41,3.41,0,0,1,.26-.53,4,4,0,0,0,0-1.49,6.58,6.58,0,0,1-.51-2.7c.17-1-1.39-4.65-1.39-4.65a4.57,4.57,0,0,1,.15-1,.8.8,0,0,0,0-.22s0,0,0,0h0a8,8,0,0,0-.57-2l.07-2.47a7.25,7.25,0,0,0-.22-3.41c-.2-.68-.33-1.23-.41-1.65l0-.14,2.07-.33a14.8,14.8,0,0,0-1.14-3.33,6.53,6.53,0,0,1-.82-2.07,6.26,6.26,0,0,1,.15-2.59,3.89,3.89,0,0,0,.44-1.6s.89-.64,1-.92a4.88,4.88,0,0,0,.3-1.26c0-.34-.11-.64-.07-.82s-.26-.85-.11-1.17a.86.86,0,0,0,.06-.31h0a4.34,4.34,0,0,0-.08-.83,2.36,2.36,0,0,0-.87-.47l0-.08,0-.2L66,37.37V37l.14-.65c.27-1.13-1.23-1.3-1.23-1.3a.79.79,0,0,0-.43-.37c-.3-.11-.05,1.7.09,1.81a6.55,6.55,0,0,1,.59.93h0l0,0-.07.07.06.39V38a1.64,1.64,0,0,0-.24.41.87.87,0,0,1,.22.64,2,2,0,0,0,.09.78s-.21-.23-.4-.18l-.73.21s-.4.07-.37.16-.28.48-.28.48l-1.08-1,0-.09a2.55,2.55,0,0,1-.1-.45l.35-.11a.75.75,0,0,0,.3-.19,1.17,1.17,0,0,0,.17-.47,6.79,6.79,0,0,1,.4-.9,2.91,2.91,0,0,0,.22-1.61,1.06,1.06,0,0,0-.17-.47c-.18-.24-.5-.34-.73-.54s-.38-.49-.66-.64a1.3,1.3,0,0,0-.82-.07,4.44,4.44,0,0,0-1.54.56.79.79,0,0,1-.51.17.69.69,0,0,1-.37-.27h0a1.91,1.91,0,0,0-.16.8,1.11,1.11,0,0,0,0,.13v.08h0a.2.2,0,0,1,0,.06.42.42,0,0,1-.1.15l-.09.12v0a.65.65,0,0,0-.11.34.34.34,0,0,0,.08.24l.18.14a2.07,2.07,0,0,0,1,2.15l0,.09a2.59,2.59,0,0,1,.2,1.18.44.44,0,0,1,0,.09s0,0,0,0h0s-1.79,0-2.21-.36-1.06.93-1.06.93-.64.12-.77,0-.88,0-.88,0a1.62,1.62,0,0,0-1.11-.41,3.31,3.31,0,0,0-.82-.46h0a.92.92,0,0,0-.4-.05,8.28,8.28,0,0,1-1.14-1.12c-.26-.39-1.48-1.84-1.48-1.85v-.28h-.11l0-.07a4.1,4.1,0,0,0-.26-.6s0-.27.08-.33a4.55,4.55,0,0,0,0-1s-.79-1.85-1.5-.47c0,0-1.34.9-.22,1.94,0,0,.45.22.51.39s.2.43.3.63l0,.09h0l0,.17v.07c-.21.12-.36.24-.32.33a2,2,0,0,1,.13.48,12.73,12.73,0,0,1,1.75,2.78s4.18,2.48,5.56,2.66l-.24,1.24a9.93,9.93,0,0,0-.06,1c0,.27-.17,1.48-.17,1.48a9.87,9.87,0,0,1-.44,2,3.38,3.38,0,0,0-.16,1.31A9,9,0,0,1,54.53,52a4,4,0,0,0-.05,1.51s-.7,1.6,1,.51c0,0,.82-.05,1.76-.08V54c0,.12,0,.25,0,.39,0,.92,0,2.18,0,3.13.07,1.69.59,5,.59,5v1.67a2.3,2.3,0,0,0,0,.48,3.12,3.12,0,0,0,.45,1.68l.13,1.12a4.38,4.38,0,0,1,.31,1.18.69.69,0,0,1,0,.11.76.76,0,0,0,0,.17,9.66,9.66,0,0,0,.29,1.72s0,1.23.2,1.3-.21.71-.32.89a.07.07,0,0,0,0,0l0,0a.86.86,0,0,0-.06.31.45.45,0,0,0,.2.43c.35.21.54.39.24.46l-.32.07,0,0a.2.2,0,0,0-.12.21.9.9,0,0,0,.11.42,4.73,4.73,0,0,0,.49.91l.14,0a.76.76,0,0,1-.08.15.58.58,0,0,1-.21.18.62.62,0,0,1-.25.09.71.71,0,0,0-.52.25.54.54,0,0,0,.06.84l1.31.45s2.26.3,2.14-.21-.2-.95-.2-.95a2,2,0,0,0-.18-.9l-.08-.13h.08a4.16,4.16,0,0,1,.38-1.33c.05,0,.06-.09.05-.12s0-.1-.11-.12l0,0-.22,0s-.07-.59.17-.8a.23.23,0,0,0,0-.17,1,1,0,0,0,0-.24h0a8.67,8.67,0,0,0-.53-1.38,1.68,1.68,0,0,1,.13-.75,18.7,18.7,0,0,0,0-2.89,8.76,8.76,0,0,0-.11-1.9,2.13,2.13,0,0,1,.2-1.31v0h0l0-.2h0c0-.34-.11-1-.16-1.25s0-2.36,0-2.36l.33-.83.59,1.44.62,1.92a1.63,1.63,0,0,1,.32.81.4.4,0,0,1,0,.06,1.11,1.11,0,0,0,0,.13,1.14,1.14,0,0,0,.19.68,3,3,0,0,0,.42,1.14,1,1,0,0,1,.26.67,11.27,11.27,0,0,0,.46,1.54,2.31,2.31,0,0,1,.13.89h0v0s0,.47,0,.86v.14h0a1.44,1.44,0,0,1,0,.32,0,0,0,0,1,0,0v-.07a3.38,3.38,0,0,0-.1.82,2.1,2.1,0,0,0,.35,1.36c.49.57.81.5.81.5s-.24.71-.53.85l0,0a.33.33,0,0,0,0,0,.34.34,0,0,0-.09.26,1.88,1.88,0,0,0,.36,1.05.57.57,0,0,0,.25.14l0,0-.1,0-.15,0a.7.7,0,0,0-.52.25.54.54,0,0,0,.06.84l1.31.45S68.42,77.25,68.3,76.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M59.69,77.59l-1.27-.45a.55.55,0,0,1-.06-.84.68.68,0,0,1,.5-.25A.59.59,0,0,0,59.1,76a.57.57,0,0,0,.2-.18.93.93,0,0,0,.14-.49s1.39-.41,1.77,0a1.05,1.05,0,0,1,.17.25,2.07,2.07,0,0,1,.18.9s.07.44.19.95S59.69,77.59,59.69,77.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M65.9,77l-1.27-.45a.55.55,0,0,1-.06-.84.67.67,0,0,1,.5-.25l.14,0,.1,0a.81.81,0,0,0,.35-.67s1.39-.41,1.77,0a1,1,0,0,1,.13.18,2,2,0,0,1,.21,1s.07.44.19.95S65.9,77,65.9,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.22,75.28a1.05,1.05,0,0,1,.17.25h0l-2.09.24a.93.93,0,0,0,.14-.49S60.84,74.87,61.22,75.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67.57,74.83v.39c-.32.54-1.9.42-2.35.15l.1,0a.81.81,0,0,0,.35-.67s1.39-.41,1.77,0A1,1,0,0,1,67.57,74.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M67.82,73.15a3.61,3.61,0,0,0-.25.53v1.4c-.35.59-2.2.39-2.45.07s-.51-1.15-.23-1.29.51-.85.51-.85-.3.07-.78-.5a2.93,2.93,0,0,1-.25-2.13,6.25,6.25,0,0,0,0-1.31,2.62,2.62,0,0,0-.13-.94,11.6,11.6,0,0,1-.44-1.54,1,1,0,0,0-.25-.67,3.05,3.05,0,0,1-.41-1.14A1.17,1.17,0,0,1,63,64a1.54,1.54,0,0,0-.3-.92l-.6-1.92-.57-1.44-.32.83s-.09,2,0,2.36.18,1.49.18,1.49a2.2,2.2,0,0,0-.2,1.31,9.15,9.15,0,0,1,.11,1.9,19.49,19.49,0,0,1,0,2.89,1.74,1.74,0,0,0-.12.75s.73,1.56.49,1.77-.16.8-.16.8.49,0,.28.21a4.35,4.35,0,0,0-.36,1.33l-2.15.25a4.46,4.46,0,0,1-.48-.91c-.28-.66.05-.59.34-.66s.1-.25-.23-.46-.14-.69-.14-.69.51-.87.34-.94-.2-1.3-.2-1.3a7.94,7.94,0,0,1-.27-1.85,3.56,3.56,0,0,0-.28-1.33l-.12-1.12a3.08,3.08,0,0,1-.39-2.11V62.55s-.49-3.34-.57-5c0-1.08,0-2.55,0-3.47,0-.52,0-.86,0-.86l7.67-.8A6.32,6.32,0,0,0,65,53.54c.08.42.2,1,.39,1.65a7.48,7.48,0,0,1,.21,3.41l-.07,2.47a6.26,6.26,0,0,1,.53,2.22,4.72,4.72,0,0,0-.14,1s1.51,3.6,1.35,4.65a6.81,6.81,0,0,0,.49,2.7A4.1,4.1,0,0,1,67.82,73.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M63.43,63.9l2.33-.31S64.44,64.94,63.43,63.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.43,61.31s.08.83-.43,1.14C65,62.45,65.91,62.3,65.43,61.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.29,58.68s-2,1.61-2.66,1.48S65.29,58.68,65.29,58.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.54,64.66s-1.48.34-1.53.93S60.54,64.66,60.54,64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M60.86,72.06s-2.09.39-1.5.66a10.54,10.54,0,0,0,1.57.48S61.61,73.23,60.86,72.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.94,73.14a.42.42,0,0,1-.19-.3l0,0s-.2.48.14.69l.11.07.2,0C59.46,73.53,59.28,73.35,58.94,73.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.64,73c.06-.05.06-.19,0-.37a1,1,0,0,0-.12.51A.43.43,0,0,1,61.64,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.32,64.16a2.38,2.38,0,0,0-.14.65,2.57,2.57,0,0,1,.16-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.12,63.23a.82.82,0,0,0,0-.2c0,.13,0,.25-.06.36A.93.93,0,0,1,66.12,63.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,70.48a1.13,1.13,0,0,0,.05-.39,1.33,1.33,0,0,0-.1.5A.48.48,0,0,1,61.27,70.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.71,73.82a7,7,0,0,0-.24,1.09l-2.15.25a4.5,4.5,0,0,1-.48-.91l-.06-.16c-.13.06-.18.2,0,.58a4.54,4.54,0,0,0,.48.91l2.15-.25A4.27,4.27,0,0,1,61.77,74C61.87,73.9,61.8,73.85,61.71,73.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.87,70.63s0,1.22.2,1.3h0c.09-.2.15-.39.07-.43s-.2-1.3-.2-1.3a7.94,7.94,0,0,1-.27-1.85A3.56,3.56,0,0,0,58.39,67l-.12-1.12a3.07,3.07,0,0,1-.39-2.11V62.08s-.49-3.34-.57-5c0-1.08,0-2.56,0-3.47,0-.17,0-.31,0-.44h-.06s0,.34,0,.86c0,.92,0,2.39,0,3.47.07,1.69.57,5,.57,5v1.72a3.07,3.07,0,0,0,.39,2.11l.12,1.11a3.56,3.56,0,0,1,.28,1.33A8,8,0,0,0,58.87,70.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.19,74.68a2.07,2.07,0,0,1-.34-.84c-.22.2,0,1,.27,1.27s2.09.51,2.45-.07V74.7A2.55,2.55,0,0,1,65.19,74.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.89,72.68a3.44,3.44,0,0,0-.25.53v.25c0-.09.1-.21.18-.36a1.06,1.06,0,0,0,.08-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3,73a3.44,3.44,0,0,0,.18-.42s-.3.07-.78-.49a2.52,2.52,0,0,1-.32-1.7,2.93,2.93,0,0,0,.25,2.13A1.27,1.27,0,0,0,65.3,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.37,69a9.47,9.47,0,0,1,0,1.05,1.53,1.53,0,0,1,0-.17,6.24,6.24,0,0,0,0-1.31,2.63,2.63,0,0,0-.12-.94,11.7,11.7,0,0,1-.44-1.54,1,1,0,0,0-.25-.67,3,3,0,0,1-.41-1.14,1.16,1.16,0,0,1-.18-.76,1.55,1.55,0,0,0-.3-.92l-.6-1.92-.57-1.44-.32.83s0,.11,0,.27l.26-.68.57,1.44L62.67,63A1.55,1.55,0,0,1,63,64a1.16,1.16,0,0,0,.18.76,3,3,0,0,0,.41,1.14,1.05,1.05,0,0,1,.25.67,11.75,11.75,0,0,0,.44,1.54A2.61,2.61,0,0,1,64.37,69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M65.86,36.36l-.13.65v.5l-.74.08-.08-.15h0a6.78,6.78,0,0,0-.57-.93c-.14-.12-.38-1.92-.09-1.81a.77.77,0,0,1,.41.37S66.13,35.24,65.86,36.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.74,37.51l-.74.08-.08-.15h0a.65.65,0,0,1,.82-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M65.93,37.86l-1,.23,0-.15-.06-.39a.67.67,0,0,1,.95-.13l0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M50.11,36.43l-1,.56-.1-.2c-.1-.21-.25-.52-.29-.63s-.5-.39-.5-.39a1.2,1.2,0,0,1,.21-1.94c.69-1.38,1.46.47,1.46.47a4.73,4.73,0,0,1,0,1c-.07.07-.08.33-.08.33a4.05,4.05,0,0,1,.25.6C50.09,36.37,50.11,36.43,50.11,36.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.11,36.43l-1,.56-.1-.2c.15-.12.67-.55.84-.53h.25C50.09,36.37,50.11,36.43,50.11,36.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M50.22,36.75,49,37.33l0-.25,0-.17s.68-.58.88-.56a1.06,1.06,0,0,0,.31,0v.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M63,40.67s-5.11.58-4.15.27a1.28,1.28,0,0,0,1-1.11,2.66,2.66,0,0,0-.19-1.18,5.07,5.07,0,0,0-.46-.92s3.91-2.15,3.12-.2a3.12,3.12,0,0,0-.22.93,2.58,2.58,0,0,0,.1.94A2.78,2.78,0,0,0,63,40.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.33,37.53a3.12,3.12,0,0,0-.22.92,1.8,1.8,0,0,1-1.29.29,2.26,2.26,0,0,1-1.16-.1,5.08,5.08,0,0,0-.46-.92S63.11,35.57,62.33,37.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 60.75,
    cy: 36.76,
    r: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63,40.67s-5.11.58-4.15.27a1.28,1.28,0,0,0,1-1.11,2.78,2.78,0,0,1,1.09-.58,1.53,1.53,0,0,1,.93,0,1.28,1.28,0,0,1,.34.16A2.78,2.78,0,0,0,63,40.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.93,37.86l-1,.23,0-.15a.86.86,0,0,1,.94-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.22,36.75,49,37.33l0-.25a8.6,8.6,0,0,1,1.18-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65,53.54a31.9,31.9,0,0,1-5.24.58,13.25,13.25,0,0,0-2.58-.07c0-.52,0-.86,0-.86l7.67-.8A6.33,6.33,0,0,0,65,53.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M67,53.07S60.5,54.19,59.8,54a28,28,0,0,0-4.29,0c-1.61,1.08-.94-.51-.94-.51A4,4,0,0,1,54.63,52a9.19,9.19,0,0,0,.27-1.51,3.52,3.52,0,0,1,.16-1.31,10.14,10.14,0,0,0,.43-2s.18-1.21.16-1.48a10.06,10.06,0,0,1,.05-1l.23-1.24c-1.33-.18-5.38-2.66-5.38-2.66a12.92,12.92,0,0,0-1.7-2.79,2,2,0,0,0-.12-.48c-.11-.28,1.49-.85,1.49-.85s1.19,1.46,1.44,1.85a8.11,8.11,0,0,0,1.1,1.12.87.87,0,0,1,.39.05h0a3.18,3.18,0,0,1,.8.46A1.54,1.54,0,0,1,55,40.5s.73-.11.85,0,.75,0,.75,0,.62-1.31,1-.93,2.14.36,2.14.36A2.56,2.56,0,0,1,61,39.31a1.53,1.53,0,0,1,.93,0,1.2,1.2,0,0,1,.37.18l1.05,1s.3-.39.27-.48.36-.16.36-.16l.71-.21c.19-.05.37.16.39.18a2.08,2.08,0,0,1-.09-.78.92.92,0,0,0-.21-.64c.62-1.53,2-.25,2-.25a2.93,2.93,0,0,1,0,1.15c-.14.32.14,1,.11,1.17s.07.48.07.82a4.79,4.79,0,0,1-.28,1.26c-.11.28-1,.92-1,.92a4,4,0,0,1-.43,1.6,6.51,6.51,0,0,0-.15,2.59,6.69,6.69,0,0,0,.8,2.07A15.11,15.11,0,0,1,67,53.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.52,41.4s-.2-.59-.37-.64a4.23,4.23,0,0,1-.51-.23l.11-.22s.67.18.77.38A1.52,1.52,0,0,1,57.52,41.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M54,40.1c0,.18-1.62.34-1.62.34l.8-.8h0A3.18,3.18,0,0,1,54,40.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 49.38,
    cy: 37.66,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 49.56,
    cy: 37.95,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 49.74,
    cy: 38.21,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 49.93,
    cy: 38.49,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 66.66,
    cy: 38.48,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 66.68,
    cy: 38.74,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 66.69,
    cy: 39,
    r: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.53,46.2s4,5,7.09,2.11C64.62,48.32,59.71,49,57.53,46.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.23,48.83s2.39.06,2.64.75v.72a.46.46,0,0,1-.44,0c-.24-.13-1.69-.87-2.2-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M55.28,48.83s2.29.06,2.53.72v.68a.44.44,0,0,1-.43,0c-.23-.12-1.61-.83-2.1-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.54,43.63a7.74,7.74,0,0,0,.93,1.59,6.25,6.25,0,0,0,1.45,1.4A28,28,0,0,1,56.54,43.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.76,40.85a4.11,4.11,0,0,0,1.43,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M55.14,41a1.91,1.91,0,0,0,1.33,2.14S55.76,42.92,55.14,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.6,39.87a12.08,12.08,0,0,1,1.06.8S66.1,39.83,65.6,39.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M60.18,38.68a.45.45,0,0,0,.17.29.46.46,0,0,0,.2,0,4.27,4.27,0,0,0,1.91-.18.72.72,0,0,0,.3-.19,1.19,1.19,0,0,0,.17-.47,6.13,6.13,0,0,1,.39-.9,3,3,0,0,0,.21-1.61,1.07,1.07,0,0,0-.16-.47c-.17-.24-.48-.34-.71-.54s-.37-.49-.63-.64a1.23,1.23,0,0,0-.8-.07,4.21,4.21,0,0,0-1.5.56.74.74,0,0,1-.49.17.69.69,0,0,1-.37-.28,2,2,0,0,0-.16.92.41.41,0,0,1,0,.14.43.43,0,0,1-.1.15.53.53,0,0,0-.1.66c.07.08.17.13.24.21s.08.36.08.55a.28.28,0,0,0,0,.19.27.27,0,0,0,.26.06.72.72,0,0,1,.28,0,.46.46,0,0,1,.24.19A3.41,3.41,0,0,1,60.18,38.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.82,38.47a.72.72,0,0,1-.3.2,4.25,4.25,0,0,1-1.91.18.43.43,0,0,1-.2,0,.45.45,0,0,1-.17-.29,3.29,3.29,0,0,0-.54-1.25.46.46,0,0,0-.24-.19.7.7,0,0,0-.28,0,.27.27,0,0,1-.26-.06.28.28,0,0,1,0-.19c0-.19,0-.4-.08-.55s-.17-.13-.24-.21a.42.42,0,0,1,0-.42.49.49,0,0,0,0,.57c.07.08.17.13.24.21s.08.36.08.55a.28.28,0,0,0,0,.19.27.27,0,0,0,.26.06.72.72,0,0,1,.28,0,.46.46,0,0,1,.24.19,3.34,3.34,0,0,1,.54,1.25.33.33,0,0,0,.34.33h0a4.27,4.27,0,0,0,1.91-.18.72.72,0,0,0,.3-.19.57.57,0,0,0,.09-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.71,35.39a.3.3,0,0,0,.07-.11.41.41,0,0,0,0-.14,2,2,0,0,1,.1-.76h0a2,2,0,0,0-.16.92A.59.59,0,0,1,58.71,35.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.8,40s2.64.35,2.88,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64.94,38.87s1.47,0,1.79.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.5,37.54s.18.24-.08.6-.49.67-.4.89c0,0,.4-.67.73-.68S96.86,37.94,96.5,37.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96.5,37.54l0,.07c.32.38.49.73.18.74s-.63.52-.71.65v0s.4-.67.73-.68S96.86,37.94,96.5,37.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M96.84,37.84c0,.08,0,.15,0,.15s0-.07,0-.15,0,0,0,0S96.84,37.76,96.84,37.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M97,37.94c-.07,0-.14.06-.14.05s0-.05.12-.09,0,0,.05,0S97,37.9,97,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.53,37.54s-.18.24.08.6.49.67.4.89c0,0-.4-.67-.73-.68S95.17,37.94,95.53,37.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.53,37.54l0,.07c-.32.38-.49.73-.18.74s.63.52.72.65v0s-.4-.67-.73-.68S95.17,37.94,95.53,37.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M95.19,37.84c0,.08,0,.15,0,.15a.31.31,0,0,0,0-.15c0-.08,0,0,0,0S95.19,37.76,95.19,37.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M95.07,37.94c.07,0,.14.06.14.05s-.05-.05-.12-.09,0,0-.05,0S95,37.9,95.07,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M95.24,39a1.88,1.88,0,0,0,.67-.13c.15-.11.79-.24.83-.06s.77.88.2.89a4.82,4.82,0,0,1-1.5-.18C95.28,39.41,95.24,39,95.24,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M96.94,39.63a5.07,5.07,0,0,1-1.5-.18c-.12-.07-.16-.33-.18-.45h0s0,.41.19.51a4.9,4.9,0,0,0,1.5.18c.17,0,.22-.06.22-.15S97.07,39.63,96.94,39.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxAccount);
export default __webpack_public_path__ + "static/media/gfx-account.23cfd93dd4dd896ad130c594b525194d.svg";
export { ForwardRef as ReactComponent };